import { useResponsiveValue } from 'braid-design-system';
import { useCallback, useRef } from 'react';

export const useScrollToTop = (scrollType: 'PAGE' | 'SECTION') => {
  const scrollToTopRef = useRef<HTMLDivElement>(null);
  const responsiveValue = useResponsiveValue();

  const scrollToTop = useCallback(() => {
    if (scrollToTopRef.current) {
      const isMobile = responsiveValue({
        mobile: true,
        tablet: false,
      });

      let offset;

      switch (scrollType) {
        case 'PAGE':
          offset = isMobile ? 60 : 350;
          break;
        case 'SECTION':
          offset = isMobile ? 85 : 172;
          break;
        default:
          offset = 0;
      }

      const top =
        scrollToTopRef?.current?.getBoundingClientRect()?.top +
        window?.scrollY -
        offset;
      window?.scrollTo({ top, behavior: 'smooth' });
    }
  }, [responsiveValue, scrollType]);

  return { scrollToTopRef, scrollToTop };
};
